import { Link } from 'react-router-dom'
import Seo from '../../components/Seo'
import { engagementArc, engagementModels, hero, principles } from '../../content'

export default function ForClients() {
  return (
    <>
      <Seo title="For clients" />
      <section className="hero">
        <span className="eyebrow">For clients</span>
        <h1 style={{ marginTop: '0.75rem' }}>Procurement advisory built around your decisions</h1>
        <p className="lede">
          We work with procurement, operations, and finance leaders at mid-market and enterprise organisations who
          want a rigorous, evidence-led route from value at stake to executed agreements.
        </p>
      </section>

      <section className="section" aria-labelledby="arc-title">
        <div className="section-head">
          <span className="eyebrow">{engagementArc.eyebrow}</span>
          <h2 id="arc-title">{engagementArc.title}</h2>
          <p className="lede">{engagementArc.text}</p>
        </div>
      </section>

      <section className="section" aria-labelledby="models-title">
        <div className="section-head">
          <span className="eyebrow">Engagement models</span>
          <h2 id="models-title">Four ways to work with us</h2>
        </div>
        <ul className="ledger unnumbered">
          {engagementModels.map((m) => (
            <li className="ledger-row" key={m.name}>
              <div>
                <h3>{m.name}</h3>
                <p className="muted" style={{ marginTop: '0.4rem', fontSize: '0.9rem' }}>
                  {m.who}
                </p>
              </div>
              <p className="what">{m.what}</p>
              <div className="outcome">
                <span className="eyebrow">You receive</span>
                {m.deliverable}
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section className="section" aria-labelledby="stance-title">
        <div className="section-head">
          <span className="eyebrow">Principles</span>
          <h2 id="stance-title">Independent, evidenced, competed</h2>
        </div>
        <div className="principles">
          {principles.map((p) => (
            <div className="principle" key={p.name}>
              <h3>{p.name}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" aria-labelledby="scope-title">
        <div className="section-head">
          <span className="eyebrow">Next step</span>
          <h2 id="scope-title">Start with the diagnostic, or with a category already in motion</h2>
          <p className="lede">
            Most clients begin with a diagnostic across the categories that matter. Where a requirement or renewal is
            already defined, we can start there directly.
          </p>
        </div>
        <div className="hero-actions" style={{ marginTop: 0 }}>
          <Link to="/contact" className="btn">
            {hero.primaryCta}
          </Link>
          <Link to="/how-it-works" className="text-link">
            How suppliers experience our process
          </Link>
        </div>
      </section>
    </>
  )
}
